var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlussign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 11.6667C5.33333 11.9319 5.43869 12.1862 5.62623 12.3738C5.81376 12.5613 6.06812 12.6667 6.33333 12.6667C6.59855 12.6667 6.8529 12.5613 7.04044 12.3738C7.22798 12.1862 7.33333 11.9319 7.33333 11.6667V7.33333H11.6667C11.9319 7.33333 12.1862 7.22798 12.3738 7.04044C12.5613 6.8529 12.6667 6.59855 12.6667 6.33333C12.6667 6.06812 12.5613 5.81376 12.3738 5.62623C12.1862 5.43869 11.9319 5.33333 11.6667 5.33333H7.33333V1C7.33333 0.734784 7.22798 0.48043 7.04044 0.292893C6.8529 0.105357 6.59855 0 6.33333 0C6.06812 0 5.81376 0.105357 5.62623 0.292893C5.43869 0.48043 5.33333 0.734784 5.33333 1V5.33333H1C0.734784 5.33333 0.48043 5.43869 0.292893 5.62623C0.105357 5.81376 0 6.06812 0 6.33333C0 6.59855 0.105357 6.8529 0.292893 7.04044C0.48043 7.22798 0.734784 7.33333 1 7.33333H5.33333V11.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlussign);
export default __webpack_public_path__ + "static/media/plussign.b606b99c09918f53dcb9b578eb796c68.svg";
export { ForwardRef as ReactComponent };